module.exports = __webpack_public_path__ + "img/single-6.ddcdca8b.png";